// hooks/requests/dashboard/sales/use-get-bestselling-products.ts
import useSWR from "swr";

import salesDashboardService from "@/services/sales-dashboard.service";
import { BestsellingProduct } from "@/types/best-selling-product.types";

export interface UseGetBestsellingProductsProps {
  startDate: string;
  endDate: string;
}

export type UseGetBestsellingProductsReturn = {
  data: BestsellingProduct[] | null;
  isLoading: boolean;
  error: Error | null;
};

const useGetBestsellingProducts = ({
  startDate,
  endDate,
}: UseGetBestsellingProductsProps): UseGetBestsellingProductsReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR(
    ["getBestsellingProducts", startDate, endDate],
    () => salesDashboardService.bestSellingProduct(startDate, endDate),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetBestsellingProducts;
